import { isMock } from '../config'
import { withOfflineCache } from '../offline-cache'
import { accesosMock } from './mock'
import { accesosReal } from './real'
import type { AccesosService } from './types'

const impl: AccesosService = isMock('accesos') ? accesosMock : accesosReal

/** Llave, instrucciones y cómo llegar siguen disponibles sin conexión (DESIGN.md §7; inventario D18). */
export const accesosService: AccesosService = {
  getKey: (stay, signal) => withOfflineCache(stay.guestCode, 'key', () => impl.getKey(stay, signal)),
  open: (stay, accessId, lang, options) => impl.open(stay, accessId, lang, options),
  getInstructions: (stay, signal) => withOfflineCache(stay.guestCode, 'instructions', () => impl.getInstructions(stay, signal)),
  getDirections: (stay, signal) => withOfflineCache(stay.guestCode, 'directions', () => impl.getDirections(stay, signal)),
}
export { deriveKeyMissing, deriveKeyStatus } from './key'
export type { Access, AccessCode, AccessInstructions, AccessKind, AccesosService, Directions, KeyMissingReason, KeyState, KeyStatus, OpenResult, PhotoStepData, TransportMode } from './types'
